<!-- Card -->
<div class="h-screen overflow-y-auto surface-0 pb-4">
    <div class="px-3">
        <p-carousel *ngIf="!showSkeleton" [value]="weeks" [numVisible]="7" [numScroll]="1" [showIndicators]="false" [showNavigators]="true" [responsiveOptions]="responsiveOptions">
            <ng-template let-week pTemplate="item">
                <div class="font-bold text-sm text-center surface-50 hover:surface-200 cursor-pointer py-3" [class.bg-primary]="week.selected" [class.text-white]="week.selected" (click)="selectDate(week.date)">
                    <div class="text-600" [class.text-white]="week.selected">{{week.dayName}}</div>
                    <div *ngIf="!showSkeleton" class="my-1">{{week.activity}}</div>
                    <p-skeleton *ngIf="showSkeleton" width="2rem" height="2rem" shape="circle" styleClass="mx-auto my-1"></p-skeleton>
                    <div *ngIf="!showSkeleton">{{week.day}}/{{week.month}}</div>
                    <p-skeleton *ngIf="showSkeleton" width="4rem" height="1.1rem" styleClass="mx-auto"></p-skeleton>
                </div>
            </ng-template>`
        </p-carousel>

        <p-carousel *ngIf="showSkeleton" [value]="[1,2,3,4,5,6,7]" [numVisible]="7" [numScroll]="1" [showIndicators]="false" [showNavigators]="true" [responsiveOptions]="responsiveOptions">
            <ng-template let-week pTemplate="item">
                <div class="font-bold text-sm text-center surface-50 hover:surface-200 cursor-pointer py-3">
                    <p-skeleton *ngIf="showSkeleton" width="2rem" height="2rem" shape="circle" styleClass="mx-auto my-1"></p-skeleton>
                    <p-skeleton *ngIf="showSkeleton" width="4rem" height="1.1rem" styleClass="mx-auto"></p-skeleton>
                </div>
            </ng-template>`
        </p-carousel>

    </div>

    <!-- Grid -->
    <div class="grid p-3">
        <!-- Left Side -->
        <div class="col-12 xl:col-7">
            <!-- Card -->
            <div class="surface-0 shadow-2 border-round">
                <!-- Card Header -->
                <div class="p-3 flex align-items-center justify-content-between">
                    <!-- Tabs -->
                    <div class="flex border-round shadow-2 text-sm">
                        <!-- <span class="py-1 px-2 border-round-left cursor-pointer" [ngClass]="{'surface-0 font-bold': wellbeing1 === 0, 'text-600 surface-100': wellbeing1 !== 0}" (click)="wellbeing1 = 0">Pie</span>
                        <span class="py-1 px-2 border-round-right cursor-pointer" [ngClass]="{'surface-0 font-bold': wellbeing1 === 1, 'text-600 surface-100': wellbeing1 !== 1}" (click)="wellbeing1 = 1">Bar</span> -->
                    </div>
                    <!-- Tabs -->
                    <!-- Title -->
                    <h4 class="text-lg uppercase font-bold mb-0">{{ 'FITNESS.WELLBEING' | translate }}</h4>
                    <!-- Title -->
                    <div class="hidden md:block"></div>
                </div>
                <!-- Card Header -->

                <!-- Card Content -->
                <div class="p-3 text-center">
                    <div>
                        <!-- Chart -->
                        <div class="mb-4">
                            <!-- <p-skeleton *ngIf="showSkeleton" width="28rem" height="15rem" styleClass="mx-auto"></p-skeleton> -->
                            <div class="chart-container" style="position: relative; height: 200px; width: 100%;">
                                <canvas id="wellbeingChart"></canvas>
                            </div>
                        </div>
                        <!-- Chart -->
                        <!-- Mini Card -->
                        <div class="border-round shadow-2 surface-0 flex text-sm font-bold lh-1 mb-3">
                            <span class="w-4 p-2 border-round-left border-right-1 border-300 flex flex-column justify-content-between cursor-pointer" [class.bg-cyan-50]="distinctMetrics[0]?.type === 'activity'"
                                (click)="createActivityChart('activity')" >
                                <label class="mb-1 block uppercase">{{ 'FITNESS.ACTIVITY' | translate }}</label>
                                <span *ngIf="!showSkeleton" class="text-cyan-500 block text-4xl">{{distinctMetrics[0]?.score || 0}}</span>
                                <p-skeleton *ngIf="showSkeleton" width="5rem" height="1.5rem" styleClass="mx-auto"></p-skeleton>
                            </span>
                            <span class="w-4 p-2 border-right-1 border-300 flex flex-column justify-content-between cursor-pointer" [class.bg-purple-50]="distinctMetrics[1]?.type === 'sleep'"
                                (click)="createActivityChart('sleep')" >
                                <label class="mb-1 block uppercase">{{ 'FITNESS.SLEEP' | translate }}</label>
                                <span *ngIf="!showSkeleton" class="text-purple-500 block text-4xl">{{distinctMetrics[1]?.score || 0}}</span>
                                <p-skeleton *ngIf="showSkeleton" width="5rem" height="1.5rem" styleClass="mx-auto"></p-skeleton>
                            </span>
                            <span class="w-4 p-2 border-round-right flex flex-column justify-content-between cursor-pointer" [class.bg-pink-50]="distinctMetrics[2]?.type === 'mental_wellbeing'"
                                 (click)="createActivityChart('mental_wellbeing')" >
                                <label class="mb-1 block uppercase">{{ 'FITNESS.MENTAL_WELLBEING' | translate }}</label>
                                <span *ngIf="!showSkeleton" class="text-pink-500 block text-4xl">{{distinctMetrics[2]?.score || 0}}</span>
                                <p-skeleton *ngIf="showSkeleton" width="5rem" height="1.5rem" styleClass="mx-auto"></p-skeleton>
                            </span>
                        </div>
                        <!-- Mini Card -->
                        <div  class="chart-container" style="position: relative; height: 200px; width: 100%;" class="w-full">
                            <canvas id="activityChart" class="w-full"></canvas>
                        </div>
                        <p-skeleton *ngIf="showSkeleton" width="28rem" height="15rem" styleClass="mx-auto"></p-skeleton>
                    </div>
                </div>
                <!-- Card Content -->
            </div>
            <!-- Card -->
        </div>
        <!-- Left Side -->

        <!-- Right Side -->
        <div class="col-12 xl:col-5">
            <!-- Card -->
            <div class="surface-0 shadow-2 border-round">
                <!-- Card Header -->
                <div class="p-3 text-center font-bold text-sm">{{ 'FITNESS.BIOMARKERS' | translate }}</div>
                <!-- Card Header -->

                <!-- Card Content -->
                <ul class="list-none p-0 m-0 flex flex-wrap" *ngIf="!showSkeleton">
                    <li class="border-top-1 border-300 w-6 p-3" [class.border-right-1]="i % 2 === 0" *ngFor="let factor of biomarkers; let i = index">
                        <h6 class="font-normal text-sm mb-2 pb-1 lh-1">{{ 'FITNESS.'+(factor.name | uppercase) | translate }}</h6>
                        <strong *ngIf="!showSkeleton" class="block font-bold text-xl lh-1 uppercase">
                            {{formatValue(factor)}}
                        </strong>
                    </li>
                </ul>
                <ul class="list-none p-0 m-0 flex flex-wrap" *ngIf="showSkeleton">
                    <li class="border-top-1 border-300 w-6 p-3" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
                        <p-skeleton *ngIf="showSkeleton" width="6rem" height="1.5rem"></p-skeleton>
                    </li>
                </ul>
                <!-- Card Content -->
            </div>
            <!-- Card -->
        </div>
        <!-- Right Side -->
    </div>
    <!-- Grid -->
</div>
<!-- Card -->
